(() => {
  const root = document.querySelector('[data-uu-pdp]');
  if (!root) return;
  const variants = JSON.parse(root.querySelector('[data-uu-variants]').textContent);
  const idField = root.querySelector('[data-uu-variant-id]');
  const priceEl = root.querySelector('[data-uu-price]');
  const wasEl = root.querySelector('[data-uu-was]');
  const btn = root.querySelector('[data-uu-atc]');
  const lowEl = root.querySelector('[data-uu-low]');

  function selected() {
    return Array.from(root.querySelectorAll('input[name^="uu-opt-"]:checked')).map(i => i.value);
  }
  function sync() {
    const opts = selected();
    const match = variants.find(v => v.options.every((o, i) => o === opts[i]));
    if (idField && match) idField.value = match.id;
    if (priceEl && match) priceEl.textContent = match.price;
    if (wasEl) {
      const show = match && match.was;
      wasEl.textContent = show ? match.was : '';
      wasEl.style.display = show ? '' : 'none';
    }
    if (btn) {
      const ok = match && match.available;
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : 'Sold out';
    }
    if (lowEl) {
      const at = Number(lowEl.dataset.at) || 0;
      const q = match ? match.qty : null;
      if (match && match.available && q != null && q > 0 && q <= at) {
        const name = match.options.length === 1 ? ' in ' + match.options[0] : '';
        lowEl.textContent = 'Only ' + q + ' left' + name;
        lowEl.hidden = false;
      } else {
        lowEl.hidden = true;
        lowEl.textContent = '';
      }
    }
    if (match) {
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
      if (match.media_index != null) showMedia(String(match.media_index));
    }
  }
  function showMedia(i) {
    const slide = root.querySelector('[data-uu-slide="' + i + '"]');
    const track = root.querySelector('[data-uu-track]');
    if (!slide || !track) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    mark(i);
  }
  function mark(i) {
    root.querySelectorAll('[data-uu-thumb]').forEach(t => {
      if (t.dataset.uuThumb === String(i)) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    const dots = root.querySelectorAll('[data-uu-dot]');
    dots.forEach(d => {
      if (d.dataset.uuDot === String(i)) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }
  root.addEventListener('change', (e) => { if (e.target.name && e.target.name.startsWith('uu-opt-')) sync(); });
  root.addEventListener('click', (e) => {
    const t = e.target.closest('[data-uu-thumb]');
    if (t) { e.preventDefault(); showMedia(t.dataset.uuThumb); }
  });
  const track = root.querySelector('[data-uu-track]');
  if (track) {
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        mark(i);
      });
    }, { passive: true });
  }
  sync();

  try { setupZoom(); } catch (err) { console.error('[uu] zoom setup failed', err); }
  try { splitDescription(); } catch (err) { console.error('[uu] description split failed', err); }

  /* Tap a product image to open it full screen; tap again to zoom in and pan. */
  function setupZoom() {
    const imgs = Array.from(root.querySelectorAll('[data-uu-slide] img'));
    if (!imgs.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let dlg, lbTrack, counter, slides = [];
    const big = (img) => {
      try { const u = new URL(img.currentSrc || img.src, location.href); u.searchParams.set('width', '2400'); u.searchParams.delete('height'); return u.toString(); }
      catch (e) { return img.currentSrc || img.src; }
    };
    const load = (i) => {
      [i - 1, i, i + 1].forEach(k => {
        const s = slides[k];
        if (!s) return;
        const im = s.querySelector('img');
        if (!im.getAttribute('src')) im.src = im.dataset.src;
      });
    };
    const current = () => Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
    const label = () => { counter.textContent = (current() + 1) + ' / ' + slides.length; };
    const unzoom = () => slides.forEach(s => { s.classList.remove('is-zoomed'); s.scrollTop = 0; s.scrollLeft = 0; });

    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'uu-lb';
      dlg.setAttribute('aria-label', 'Product images');
      const bar = document.createElement('div'); bar.className = 'uu-lb__bar';
      counter = document.createElement('span'); counter.className = 'uu-lb__n';
      const x = document.createElement('button'); x.type = 'button'; x.className = 'uu-lb__x'; x.textContent = 'Close';
      bar.append(counter, x);
      lbTrack = document.createElement('div'); lbTrack.className = 'uu-lb__track';
      imgs.forEach(img => {
        const s = document.createElement('div'); s.className = 'uu-lb__slide';
        const im = document.createElement('img'); im.alt = img.alt || ''; im.decoding = 'async'; im.dataset.src = big(img);
        s.append(im); lbTrack.append(s); slides.push(s);
      });
      const hint = document.createElement('p'); hint.className = 'uu-lb__hint';
      hint.textContent = slides.length > 1 ? 'Tap to zoom \u00b7 Swipe for more' : 'Tap to zoom';
      dlg.append(bar, lbTrack, hint);
      document.body.append(dlg);

      x.addEventListener('click', () => dlg.close());
      dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; unzoom(); });
      let raf;
      lbTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => { const i = current(); label(); load(i); });
      }, { passive: true });
      lbTrack.addEventListener('click', (e) => {
        const s = e.target.closest('.uu-lb__slide');
        if (!s) return;
        if (s.classList.contains('is-zoomed')) { s.classList.remove('is-zoomed'); s.scrollTop = 0; s.scrollLeft = 0; return; }
        const r = s.getBoundingClientRect();
        const rx = (e.clientX - r.left) / r.width, ry = (e.clientY - r.top) / r.height;
        s.classList.add('is-zoomed');
        requestAnimationFrame(() => {
          s.scrollLeft = rx * s.scrollWidth - s.clientWidth / 2;
          s.scrollTop = ry * s.scrollHeight - s.clientHeight / 2;
        });
      });
    }

    function open(i) {
      if (!dlg) build();
      document.documentElement.style.overflow = 'hidden';
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: 'auto' });
      load(i);
      counter.textContent = (i + 1) + ' / ' + slides.length;
    }

    imgs.forEach((img, i) => {
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');
      img.setAttribute('aria-label', 'Zoom image ' + (i + 1));
      img.addEventListener('click', () => open(i));
      img.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
    });
    void reduce;
  }

  /* Split the product description into lead / highlights / fit table / fabric accordion. */
  function splitDescription() {
    const tpl = root.querySelector('[data-uu-desc]');
    const out = root.querySelector('[data-uu-desc-out]');
    if (!tpl || !out) return;
    const doc = new DOMParser().parseFromString('<div>' + tpl.innerHTML + '</div>', 'text/html');
    const box = doc.body.firstElementChild;
    if (!box) return;

    let intro = '';
    const feats = [];
    const label = Array.from(box.querySelectorAll('p,h2,h3,h4,h5,h6,strong,span')).find(el => /^fabric\s*(&|and)\s*construction$/i.test(clean(el.textContent)));
    if (label && label.parentElement && label.parentElement !== box) {
      const sec = label.parentElement;
      const n = label.nextElementSibling;
      if (n && n.tagName === 'P') intro = clean(n.textContent);
      sec.querySelectorAll('svg').forEach(svg => {
        const t = svg.nextElementSibling;
        if (!t) return;
        const row = svg.parentElement;
        const d = row && row.nextElementSibling;
        const icon = svg.cloneNode(true);
        ['width', 'height', 'style'].forEach(a => icon.removeAttribute(a));
        icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        feats.push({ icon: icon, t: clean(t.textContent), d: d ? clean(d.textContent) : '' });
      });
      sec.remove();
    }

    const flat = doc.createElement('div');
    flat.innerHTML = box.innerHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h\d)>/gi, '\n');
    const lines = flat.textContent.split('\n').map(clean).filter(Boolean);
    const si = lines.findIndex(s => /^sizing\b/i.test(s));
    if (si < 0) return;

    let fit = lines[si].replace(/^sizing\b[:\s]*/i, '').trim();
    let next = si + 1;
    if (!fit && lines[next]) { fit = lines[next]; next++; }
    const rest = lines.slice(next);
    const modelLine = rest.find(s => /^model\b/i.test(s));
    let model = '';
    if (modelLine) {
      const m = modelLine.match(/model\s+is\s*(.+?)[\s,]*wears\s+(?:a\s+)?size\s+(\S+)/i);
      model = m ? m[1].trim() + ' \u00b7 Wears size ' + m[2] : modelLine.replace(/^model\s+is\s*/i, '');
    }
    const fabLine = rest.find(s => /\d+\s*%/.test(s));
    const fabric = fabLine ? fabLine.replace(/\s+(?=\d+\s*%)/g, ' \u00b7 ') : '';

    const leadEl = root.querySelector('[data-uu-lead]');
    if (leadEl) {
      let after = leadEl;
      lines.slice(0, si).forEach(s => {
        if (s === clean(leadEl.textContent)) return;
        const p = document.createElement('p');
        p.className = 'uu-pdp__lead';
        p.textContent = s;
        after.after(p);
        after = p;
      });
    }

    /* Fit reference: lines after a "Fit reference" heading, e.g. 6'0" / 180 lb wears L (Joseph, gifted) */
    const fri = rest.findIndex(s => /^fit reference\b/i.test(s));
    const refs = [];
    if (fri >= 0) {
      for (let i = fri + 1; i < rest.length; i++) {
        const s = rest[i];
        if (/\bwears\s+\S+/i.test(s)) refs.push(s); else break;
      }
    }

    const dl = out.querySelector('[data-uu-fit]');
    [['Fit', fit], ['Model', model], ['Fabric', fabric]].forEach(([k, v]) => {
      if (!v) return;
      const dt = document.createElement('dt'); dt.textContent = k;
      const dd = document.createElement('dd'); dd.textContent = v;
      dl.append(dt, dd);
    });
    if (refs.length) {
      const dt = document.createElement('dt'); dt.textContent = 'Also worn by';
      const dd = document.createElement('dd');
      refs.forEach((s, i) => { if (i) dd.append(document.createElement('br')); dd.append(document.createTextNode(s)); });
      dl.append(dt, dd);
    }
    if (!dl.children.length) dl.remove();

    const det = root.querySelector('[data-uu-desc-block]');
    const hl = out.querySelector('[data-uu-hl]');
    if (feats.length) {
      feats.forEach(f => {
        const b = document.createElement('button');
        b.type = 'button';
        b.append(f.icon.cloneNode(true));
        const s = document.createElement('span'); s.textContent = f.t;
        b.append(s);
        b.addEventListener('click', () => {
          if (!det) return;
          det.open = true;
          const y = det.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
        hl.append(b);
      });
    } else {
      hl.remove();
    }

    if (det) {
      if (intro || feats.length) {
        det.open = false;
        det.querySelector('summary').textContent = 'Fabric & construction';
        const body = det.querySelector('.uu-acc__body');
        body.textContent = '';
        if (intro) { const p = document.createElement('p'); p.className = 'uu-acc__intro'; p.textContent = intro; body.append(p); }
        if (feats.length) {
          const ul = document.createElement('ul'); ul.className = 'uu-feat';
          feats.forEach(f => {
            const li = document.createElement('li');
            const wrap = document.createElement('div');
            const b = document.createElement('b'); b.textContent = f.t;
            wrap.append(b);
            if (f.d) { const p = document.createElement('p'); p.textContent = f.d; wrap.append(p); }
            li.append(f.icon, wrap);
            ul.append(li);
          });
          body.append(ul);
        }
      } else {
        det.remove();
      }
    }
    out.hidden = false;
  }
  function clean(s) { return (s || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); }
})();
